import { useEffect, useState } from "react";

import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView, trackEvent } from "@tm/insurance/analytics/xdm";
import { usePlanType } from "@tm/ui";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { InnerContentWrap } from "../../CommonStyle/CommonStyles.style";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import RichText from "../RichText/RichText";
import {
  LandingFaqAns,
  LandingFaqInfo,
  LandingFaqList,
  LandingFaqQues,
  LandingFaqStyle,
  LandingFaqTitle,
} from "./LandingFaq.style";

interface FaqType {
  customTitle?: string;
  customFaq?: string;
  faq: {
    ques?: TextNodeType | string;
    info?: string;
  }[];
  margin?: string;
  icon?: string;
  customInfo?: string;
  isCommonLanding?: boolean;
}

const analytics = getAnalytics();

const LandingFaq = ({
  customTitle,
  customFaq,
  faq,
  margin,
  customInfo,
  icon,
  isCommonLanding,
}: FaqType) => {
  const [exp, setExp] = useState(-1);
  const device = useBreakpointV2();
  const { type } = usePlanType();

  const handleClick = (index: number) => {
    analytics?.trackLandingEvents(
      {
        actionType: `faq_section${index + 1}_clicked`,
      },
      "pageView",
      type
    );
    trackEvent({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `faq_section${index + 1}_clicked`,
      },
    });
    exp != index ? setExp(index) : setExp(-1);
  };

  useEffect(() => {
    faq?.map((item, index) => {
      const element = document.getElementById(`faq${index + 1}`);
      const observer = new IntersectionObserver(obCallback, {
        threshold: 1,
      });
      element && observer.observe(element);
      function obCallback(entries: any) {
        if (entries[0].isIntersecting) {
          analytics?.trackLandingEvents(
            {
              actionType: `faq_section${index + 1}_seen`,
            },
            "pageView",
            type
          );
          trackComponentView({
            name: `faq_section${index + 1}_seen`,
            type: "faq",
          });
          observer.disconnect();
        }
      }
    });
  }, [faq]);

  return (
    <LandingFaqStyle
      margin={margin}
      customFaq={customFaq}
      isCommonLanding={isCommonLanding}
    >
      <InnerContentWrap>
        {customTitle && (
          <LandingFaqTitle
            marginLeft={device === "sm" ? "16px" : ""}
            marginBottom="16px"
          >
            {customTitle && <FormattedText value={customTitle} />}
          </LandingFaqTitle>
        )}
        {customInfo && (
          <LandingFaqInfo>
            {icon && <img src={icon} alt="Bot Icon" />}
            <FormattedText value={customInfo} />
          </LandingFaqInfo>
        )}
        <LandingFaqList customFaq={customFaq} isCommonLanding={isCommonLanding}>
          {faq.map((item, index: number) => {
            return (
              <li
                className={`${exp == index ? "open" : "close"}`}
                key={index}
                id={`faq${index + 1}`}
              >
                <LandingFaqQues
                  customFaq={customFaq}
                  onClick={() => handleClick(index)}
                >
                  {item.ques && <FormattedText value={item.ques} />}
                </LandingFaqQues>
                {exp == index && (
                  <LandingFaqAns>
                    <p>{item.info && <RichText value={item.info} />}</p>
                  </LandingFaqAns>
                )}
              </li>
            );
          })}
        </LandingFaqList>
      </InnerContentWrap>
    </LandingFaqStyle>
  );
};

export default LandingFaq;
